import { ActionReducerMapBuilder, PayloadAction } from "@reduxjs/toolkit";
import { GameTypeEnum } from "enums/game";
import { ResponseEnum } from "enums/response";
import { NoInfer } from "react-redux";
import {
  GameListResponseType,
  GameStateType,
  SubGameResponseType,
} from "types/game";

import { getGameList, getSubGameList } from "./game.thunk";

export const extraReducers = (
  builder: ActionReducerMapBuilder<NoInfer<GameStateType>>
) => {
  builder
    .addCase(getGameList.pending, (state: GameStateType) => {
      state.isLoading = true;
    })
    .addCase(
      getGameList.fulfilled,
      (
        state: GameStateType,
        action: PayloadAction<GameListResponseType | undefined>
      ) => {
        state.isLoading = false;
        if (!action.payload) return;

        state.categoryGameList = [...action.payload.data];
      }
    )
    .addCase(getGameList.rejected, (state: GameStateType) => {
      state.isLoading = false;
    });
  builder
    .addCase(getSubGameList.pending, (state: GameStateType) => {
      state.isLoading = true;
    })
    .addCase(
      getSubGameList.fulfilled,
      (
        state: GameStateType,
        action: PayloadAction<SubGameResponseType | undefined>
      ) => {
        if (!action.payload) {
          state.isLoading = false;
          return;
        }
        if (action.payload.msg === ResponseEnum.msgErrorProvider) {
          return {
            ...state,
            msgError: "Invalid Provider",
            isLoading: false,
          };
        }

        const subGames = Array.isArray(action.payload.data)
          ? action.payload.data
          : [];

        if (action.payload.provider) {
          return {
            ...state,
            dataSubGame: {
              ...action.payload,
              data: subGames,
            },
            isLoading: false,
          };
        }

        // check Feature game,Show 50 live game 30 random game
        if (
          action.payload.featured !== undefined ||
          (!action.payload.lobby &&
            action.payload.game_type === GameTypeEnum.LiveCasino)
        ) {
          return {
            ...state,
            dataSubGameFeatured: [...state.dataSubGameFeatured, ...subGames],
            isLoading: false,
          };
        }

        // if (action.payload.game_type === GameTypeEnum.LiveCasino) {
        //   return {
        //     ...state,
        //     categoryGameLiveCasino: [...action.payload.data],
        //     isLoading: false,
        //   };
        // }

        // if (action.payload.game_type === GameTypeEnum.Slot) {
        //   return {
        //     ...state,
        //     categoryGameSlots: [...action.payload.data],
        //     isLoading: false,
        //   };
        // }

        // if (action.payload.game_type === GameTypeEnum.ESport) {
        //   return {
        //     ...state,
        //     categoryGameESport: [...action.payload.data],
        //     isLoading: false,
        //   };
        // }

        // remaining Sport
        // return {
        //   ...state,
        //   categoryGameSport: [...action.payload.data],
        //   isLoading: false,
        // };
      }
    )
    .addCase(getSubGameList.rejected, (state: GameStateType) => {
      state.isLoading = false;
    });
};
